import { createLifeGrid } from '../core/cells';

export const gosperGliderGun = createLifeGrid({
  "24,0": true,
  "22,1": true,
  "24,1": true,
  "12,2": true,
  "13,2": true,
  "20,2": true,
  "21,2": true,
  "34,2": true,
  "35,2": true,
  "11,3": true,
  "15,3": true,
  "20,3": true,
  "21,3": true,
  "34,3": true,
  "35,3": true,
  "0,4": true,
  "1,4": true,
  "10,4": true,
  "16,4": true,
  "20,4": true,
  "21,4": true,
  "0,5": true,
  "1,5": true,
  "10,5": true,
  "14,5": true,
  "16,5": true,
  "17,5": true,
  "22,5": true,
  "24,5": true,
  "10,6": true,
  "16,6": true,
  "24,6": true,
  "11,7": true,
  "15,7": true,
  "12,8": true,
  "13,8": true,
});

export const simkinGliderGun = createLifeGrid({
  "0,0": true,
  "1,0": true,
  "7,0": true,
  "8,0": true,
  "0,1": true,
  "1,1": true,
  "7,1": true,
  "8,1": true,
  "4,3": true,
  "5,3": true,
  "4,4": true,
  "5,4": true,
  "22,9": true,
  "23,9": true,
  "25,9": true,
  "26,9": true,
  "21,10": true,
  "27,10": true,
  "21,11": true,
  "28,11": true,
  "31,11": true,
  "32,11": true,
  "21,12": true,
  "22,12": true,
  "23,12": true,
  "27,12": true,
  "31,12": true,
  "32,12": true,
  "26,13": true,
  "20,17": true,
  "21,17": true,
  "20,18": true,
  "21,19": true,
  "22,19": true,
  "23,19": true,
  "23,20": true,
});